import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./store/authContext";

import { Provider } from "react-redux";
import store from "./store/store";

import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from "redux-persist";

let persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AuthContextProvider>
          <BrowserRouter >
            <App />
          </BrowserRouter>
        </AuthContextProvider >
      </PersistGate>
    </Provider>
  </React.StrictMode>
  ,
  document.getElementById("root")
);
